import { TabEvent as DashboardTabEvent } from '@deephaven/dashboard';
export { default as ChartEvent } from "./ChartEvent.js";
export { default as ConsoleEvent } from "./ConsoleEvent.js";
export { default as InputFilterEvent } from "./InputFilterEvent.js";
export { default as IrisGridEvent } from "./IrisGridEvent.js";
export { default as MarkdownEvent } from "./MarkdownEvent.js";
export { default as NotebookEvent } from "./NotebookEvent.js";
export { default as PandasEvent } from "./PandasEvent.js";
/**
 * @deprecated Use TabEvent from @deephaven/dashboard
 */
export var TabEvent = DashboardTabEvent;
//# sourceMappingURL=index.js.map